import React from "react";

function CaseStudyHero() {
  return (
    <section
      style={{
        background:
          "linear-gradient(135deg,#002147,#003d5c)",
        color: "#fff",
        padding: "140px 20px"
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          textAlign: "center"
        }}
      >
        <h1
          style={{
            fontSize: "clamp(3rem,5vw,5rem)",
            fontFamily:
              "Playfair Display, serif",
            marginBottom: "24px"
          }}
        >
          Case Studies
        </h1>

        <p
          style={{
            maxWidth: "850px",
            margin: "0 auto",
            color: "#e2e8f0",
            lineHeight: 1.9,
            fontSize: "1.15rem"
          }}
        >
          Explore how strategic marketing,
          technology and optimization can
          improve business outcomes across
          different industries.
        </p>
      </div>
    </section>
  );
}

export default CaseStudyHero;